module.exports = __webpack_public_path__ + "img/add.447ef5ba.svg";